var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMemberId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 60.5C47.0685 60.5 60.5 47.0685 60.5 30.5C60.5 13.9314 47.0685 0.5 30.5 0.5C13.9314 0.5 0.5 13.9314 0.5 30.5C0.5 47.0685 13.9314 60.5 30.5 60.5Z",
    fill: "#FCF7F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.16 20.5939C33.6405 21.0745 33.9395 21.707 34.006 22.3834C34.0725 23.0598 33.9024 23.7383 33.5246 24.3033C33.1468 24.8683 32.5848 25.2848 31.9343 25.4819C31.2839 25.6789 30.5852 25.6442 29.9574 25.3838C29.3296 25.1234 28.8116 24.6534 28.4915 24.0538C28.1715 23.4542 28.0693 22.7622 28.2023 22.0957C28.3354 21.4292 28.6955 20.8295 29.2212 20.3987C29.7469 19.9679 30.4057 19.7328 31.0854 19.7334C31.4708 19.7333 31.8524 19.8093 32.2084 19.957C32.5644 20.1046 32.8878 20.3211 33.16 20.5939V20.5939Z",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2891 17.2861H26.7161C25.1133 17.2861 23.814 18.5854 23.814 20.1882V28.7954C23.814 30.3982 25.1133 31.6975 26.7161 31.6975H35.2891C36.8919 31.6975 38.1912 30.3982 38.1912 28.7954V20.1882C38.1912 18.5854 36.8919 17.2861 35.2891 17.2861Z",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6797 31.331V30.4512C25.6797 29.4532 26.0761 28.4962 26.7817 27.7906C27.4874 27.0849 28.4444 26.6885 29.4424 26.6885H32.7277C33.7256 26.6885 34.6827 27.0849 35.3883 27.7906C36.0939 28.4962 36.4903 29.4532 36.4903 30.4512V31.2428",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2621 14.1621C42.044 13.9435 41.7849 13.77 41.4996 13.6517C41.2143 13.5334 40.9084 13.4725 40.5996 13.4727H21.7706C21.1467 13.4732 20.5485 13.7213 20.1076 14.1627C19.6666 14.604 19.4189 15.2024 19.4189 15.8263V44.0697C19.4189 44.6936 19.6666 45.292 20.1076 45.7334C20.5485 46.1747 21.1467 46.4229 21.7706 46.4233H40.5996C41.2236 46.4222 41.8218 46.174 42.2633 45.7329C42.7048 45.2918 42.9536 44.6938 42.9553 44.0697V15.8263C42.9554 15.5169 42.8942 15.2105 42.7752 14.9249C42.6562 14.6392 42.4818 14.38 42.2621 14.1621V14.1621Z",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7873 35.8252H23.5869",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7873 39.2002H23.5869",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7873 42.5771H23.5869",
    stroke: "#6D39D4",
    strokeWidth: 1.37491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberId);
export default __webpack_public_path__ + "static/media/member-id.156c06030e7e61861d7c1f90dcd5a210.svg";
export { ForwardRef as ReactComponent };